var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "p",
                {
                  staticClass: "body-1"
                },
                [
                  _vm._v(
                    " A list of our accepted domains and transfer pricing is available "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://www.greengeeks.com/support/article/domain-pricing/",
                        target: "_blank"
                      }
                    },
                    [_vm._v("here")]
                  ),
                  _vm._v(". ")
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }